const INITIAL_STATE = {
    prices: { values: [], error: null, loading: false },
  };
  
  export default function (state = INITIAL_STATE, action) {
    return {
      ...state,
      prices: { values: action.payload, error: null, loading: true },
    };
  }
  